module.exports = __webpack_public_path__ + "img/gmail.29d9541b.png";